import { render, staticRenderFns } from "./tab-trainings.vue?vue&type=template&id=4ef2cf9c"
import script from "./tab-trainings.vue?vue&type=script&lang=js"
export * from "./tab-trainings.vue?vue&type=script&lang=js"
import style0 from "./tab-trainings.vue?vue&type=style&index=0&id=4ef2cf9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports